import type { ClientOptions, StackFrame } from "@sentry/types";
import { getFramesFromEvent } from "@sentry/utils";

/**
 * URL schemes used by mobile in-app browsers (Facebook/Instagram on Android use `iabjs://`)
 * to inject their own instrumentation scripts (e.g. `navigation_performance_logger_android`).
 *
 * These scripts call back into native code via JavascriptInterface bridges. When the user
 * navigates and the WebView tears down the bridge, queued callbacks throw errors like
 * "Error invoking postMessage: Java object is gone" — which are unactionable for us.
 */
const IN_APP_BROWSER_SCHEMES = ["iabjs://"];

const isInAppBrowserFrame = (frame: StackFrame): boolean =>
  IN_APP_BROWSER_SCHEMES.some(
    scheme => frame.filename?.startsWith(scheme) || frame.abs_path?.startsWith(scheme)
  );

const inAppBrowserBridge: NonNullable<ClientOptions["beforeSend"]> = event => {
  const frames = getFramesFromEvent(event);
  if (!frames?.length) return event;

  if (frames.some(isInAppBrowserFrame)) return null;

  return event;
};

export { inAppBrowserBridge };
